<template>
  <div class="page-container base-batch-list">
    <div class="page-title-container">
      <h1 class="page-title">Relaciones de códigos</h1>
    </div>

    <div class="table-container">
      <div class="table-header">
        <div
          class="d-flex flex-column flex-md-row justify-content-between align-items-start position-relative"
        >
          <div class="w-full w-md-auto md-flex-1">
            <div
              class="d-flex justify-content-between align-items-center justify-content-lg-start"
            >
              <button
                type="button"
                class="filter d-flex align-items-center justify-content-between border-0"
                @click="showFilters = !showFilters"
              >
                <i class="ri-filter-3-line text-dark font-weight-bold"></i>
                <div>Filtrar</div>
              </button>

              <div class="d-flex d-md-none">
                <button
                  type="button"
                  class="button-tooltip text-dark font-weight-bold"
                  v-b-tooltip.hover
                  title="Recargar"
                  @click="loadData()"
                >
                  <i class="ri-loop-right-line"></i>
                </button>

                <button
                  type="button"
                  class="button-tooltip text-dark font-weight-bold ml-0"
                  v-b-tooltip.hover
                  v-if="$can('manage', 'relaciones_codigo_descarga')"
                  title="Descargar"
                  @click="downloadReport()"
                >
                  <i class="ri-download-2-line"></i>
                </button>
              </div>
            </div>
          </div>

          <section
            class="w-full w-md-auto md-flex-1 d-flex justify-content-end align-items-center mt-2 mt-md-0"
          >
            <div class="d-none d-md-flex">
              <button
                type="button"
                class="button-tooltip text-dark font-weight-bold"
                v-b-tooltip.hover
                title="Recargar"
                @click="loadData()"
              >
                <i class="ri-loop-right-line"></i>
              </button>

              <button
                  type="button"
                  class="button-tooltip text-dark font-weight-bold ml-0"
                  v-b-tooltip.hover
                  title="Descargar"
                  v-if="$can('manage', 'relaciones_codigo_descarga')"
                  @click="downloadReport()"
                >
                  <i class="ri-download-2-line"></i>
                </button>
            </div>

            <div class="w-full w-md-auto d-flex flex-column flex-md-row">
              <SearchBar
                placeholder="Buscar por nombre, N° Recargador o código Bolsa"
                @search="onSearch"
                @input="search = $event"
                class="flex-1"
              />

              <div class="text-right mt-2 mt-md-0">
                <b-button
                  :to="{ name: 'celulares-relationships-create' }"
                  variant="none"
                  class="button button-primary ml-md-2"
                  v-if="$can('manage', 'relaciones_codigo_agregar')"
                  >Agregar</b-button
                >
              </div>
            </div>
          </section>

          <filter-menu
            :show="showFilters"
            @hide="showFilters = false"
            :options="filterOptions"
            :selectedOptionFilter="filters"
            @setFilters="setFilters"
          ></filter-menu>
        </div>

        <div
          class="w-100 d-flex flex-wrap align-items-center mt-2"
          v-if="showFiltersList"
        >
          <span
            v-for="(val, name) in filterList"
            v-bind:key="name"
            class="filter-item"
          >
            {{ getFilterName(name, val) }}
            <button
              type="button"
              class="text-white p-0 bg-transparent border-0 ml-2"
              @click="deleteFilter(name)"
            >
              <i class="ri-close-circle-line"></i>
            </button>
          </span>
        </div>
      </div>

      <div class="mb-0">
        <!-- Mobile -->
        <div class="custom-table-mobile d-xl-none">
          <section class="custom-table-mobile-header">
            <div>
              <span>Código principal</span>
            </div>

            <div>
              <span>Nombres y Apellidos</span>
            </div>
          </section>

          <div class="custom-table-mobile-body">
            <div class="custom-table-mobile-row" v-for="o in list" :key="o.id">
              <div class="custom-table-mobile-grid">
                <div>
                  <span>{{ o.pusherPDVIdentifier || '-' }}</span>
                </div>
                <div>
                  <span>{{ o.pusherPDVNames || "-" }}</span>
                </div>
                <div>
                  <button
                    type="button"
                    class="border-0 bg-transparent"
                    @click="o.showMobileData = !o.showMobileData"
                  >
                    <span v-if="!o.showMobileData">
                      <i class="ri-arrow-down-s-line"></i>
                    </span>
                    <span v-else>
                      <i class="ri-arrow-up-s-line"></i>
                    </span>
                  </button>
                </div>
              </div>

              <div class="custom-table-mobile-options mt-3">

                <router-link
                  :to="{
                    name: 'celulares-relationships-edit',
                    params: { id: o.id },
                  }"
                  v-if="$can('manage', 'relaciones_codigo_editar')"
                  class="mr-3"
                  >Editar</router-link
                >

                <a href="" @click.prevent="openChangeStatus(o)" class="mr-2"
                   v-if="$can('manage', 'relaciones_codigo_activar')"
                   :class="{'text-danger': getStatus(o.status).action === 'Suspender'}"
                  >{{ getStatus(o.status).action }}</a
                >
              </div>

              <div class="pt-3" v-if="o.showMobileData">
                <ul class="list-unstyled p-0">
                  <li>
                    <span class="font-weight-medium d-inline-block mr-2"
                      >Zonal:</span
                    >
                    <span>{{ o.pusherPDVZonal ? o.pusherPDVZonal.description : "-" }}</span>
                  </li>
                  <li>
                    <span class="font-weight-medium d-inline-block mr-2"
                      >N° Recargador:</span
                    >
                    <span>{{ o.pusherPDVRechargerNumber || '-' }}</span>
                  </li>
                  <li>
                    <span class="font-weight-medium d-inline-block mr-2"
                      >Código Bolsa:</span
                    >
                    <span>{{ o.relatedIdentifier || '-' }}</span>
                  </li>
                  <li>
                    <span class="font-weight-medium d-inline-block mr-2"
                      >Estado:</span
                    >
                    <span :class="`badge ${getStatus(o.status).color}`">{{
                      getStatus(o.status).label
                    }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <!-- Desktop -->
        <table class="custom-table w-100 d-none d-xl-table">
          <thead>
            <tr>
              <th>
                Código principal
              </th>
              <th>
                Nombres y Apellidos
              </th>
              <th>
                Zonal
              </th>
              <th>
                N° Recargador
              </th>
              <th>
                Código Bolsa
              </th>
              <th>Estado</th>
              <th class="pr-md-3"
                  v-if="$can('manage', 'relaciones_codigo_editar') || $can('manage', 'relaciones_codigo_activar')">Opciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="o in list" :key="o.id">
              <td class="cell-center px-1">{{ o.pusherPDVIdentifier || '-' }}</td>
              <td class="pl-3">{{ o.pusherPDVNames || "" }}</td>
              <td class="cell-center">
                {{ o.pusherPDVZonal ? o.pusherPDVZonal.description : "-" }}
              </td>
              <td class="cell-center">
                {{ o.pusherPDVRechargerNumber || '-' }}
              </td>
              <td class="cell-center">
                {{ o.relatedIdentifier || '-' }}
              </td>
              <td class="cell-center">
                <span :class="`badge ${getStatus(o.status).color}`">{{
                  getStatus(o.status).label
                }}</span>
              </td>
              <td class="cell-center d_option pr-md-2 position-relative"
                  v-if="$can('manage', 'relaciones_codigo_editar') || $can('manage', 'relaciones_codigo_activar')">
                <DropdownTable>
                  <template v-slot:dropdown-content>
                    <DropdownItem
                      text="Editar"
                      :to="{
                        name: 'celulares-relationships-edit',
                        params: { id: o.id }
                      }"
                      v-if="$can('manage', 'relaciones_codigo_editar')"
                    />

                    <DropdownItem
                      :text="getStatus(o.status).action"
                      v-if="$can('manage', 'relaciones_codigo_activar')"
                      @click="openChangeStatus(o)"
                    />
                  </template>
                </DropdownTable>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="table-footer d-flex justify-content-end align-items-center">
        <pagination
          :total="total"
          :page="page"
          :page-size="pageSize"
          :pages="pages"
          :changePage="changePage"
          :changePageSize="changePageSize"
          v-if="list.length"
        />

        <div class="table-no-results" v-else>
          <p class="m-0 px-3">
            No se encontraron resultados que coincidan con los criterios
            seleccionados.
          </p>
        </div>
      </div>
    </div>

    <ConfirmationModal
      :show="confirmationModal.show"
      @hide="closeConfirmationModal"
      :data="confirmationModal"
      @confirm="confirmModal"
    />
  </div>
</template>

<script>
import {
  Alert,
  Constants,
  DropdownItem,
  DropdownTable,
  FilterMenu,
  FilterMixin,
  PaginationMixin,
  SearchBar,
  Util,
  ConfirmationModal,
  ConfirmationModalMixin,
} from "wize-admin";

import { RelationshipsService } from "../../Core/Services";

import { Constants as LocalConstants } from "@/core/utils";

import fileDownload from "js-file-download"

import geoDataMixin from "@/core/Mixins/geoDataMixin"

export default {
  mixins: [
    FilterMixin,
    PaginationMixin,
    ConfirmationModal,
    ConfirmationModalMixin,
    geoDataMixin
  ],
  components: {
    SearchBar,
    DropdownTable,
    DropdownItem,
    FilterMenu,
    ConfirmationModal,
  },
  data() {
    return {
      list: [],
      zonalList: [],
      tooltipType: null,
      pageSize: 100,
      filterOptions: [
        {
          label: "Zonal",
          key: "zonalIds",
          type: Constants.TypeFilters.MULTIPLE,
          options: [],
        },
        {
          label: "Estado",
          key: "status",
          type: Constants.TypeFilters.SINGLE,
          options: [
            LocalConstants.PushersStatus.ACTIVE,
            LocalConstants.PushersStatus.INACTIVE
          ],
        }
      ],
    };
  },
  methods: {
    async loadData() {
      try {
        await this.$store.dispatch("app/loading", true);

        const params = {
          page: this.page - 1,
          size: this.pageSize,
        };

        const data = { search: this.search, ...this.filters };
        const response = await RelationshipsService.list(data, params);

        this.list = response.payload.content.map((item) => {
          return {
            ...item,
            showMobileData: false,
          };
        });

        this.total = response.payload.totalElements;
        this.pages = response.payload.totalPages;
      } catch (e) {
        console.error(e);
        Alert.error(e.errors.message);
      } finally {
        await this.$store.dispatch("app/loading", false);
      }
    },
    async downloadReport() {
      try {
        await this.$store.dispatch("app/loading", true);
        const data = { search: this.search, ...this.filters };
        const response = await RelationshipsService.download(data);
        fileDownload(response.data, Util.getFileName(response));
      } catch (error) {
        Alert.error(error);
      } finally {
        await this.$store.dispatch("app/loading", false);
      }
    },
    getStatus(key) {
      return Util.searchValue(key, LocalConstants.RelationsStatus);
    },
    getIdentifierType(key) {
      return Util.searchValue(key, Constants.IdentifierType);
    },
    openChangeStatus(o) {
      this.selectedOption = o;
      this.openConfirmationModal({
        title: "Cambiar estado",
        description: "¿Está seguro que desea cambiar el estado?",
        acceptText: "Aceptar",
        action: "update",
      });
    },
    confirmModal() {
      this.closeConfirmationModal();
      if (this.confirmationModal.action === "update") this.changeStatus();
    },
    async changeStatus() {
      try {
        await this.$store.dispatch("app/loading", true);

        let status = this.selectedOption.status;

        if (status == LocalConstants.PushersStatus.ACTIVE.key) {
          status = LocalConstants.PushersStatus.INACTIVE.key;
        } else if (status == LocalConstants.PushersStatus.INACTIVE.key) {
          status = LocalConstants.PushersStatus.ACTIVE.key;
        }

        await RelationshipsService.changeStatus(this.selectedOption.id, status);
        await this.loadData();
        Alert.success("Estado actualizado correctamente");
      } catch (ex) {
        console.error(ex);
        Alert.error(ex.errors.message);
      } finally {
        await this.$store.dispatch("app/loading", false);
      }
    },
  },
  async mounted() {
    // await this.loadData();
  },
  async created() {
    await this.loadData(this.page, this.pageSize);
    await this.getZonalList()
    const zonalOptions = this.filterOptions.find((o) => o.key === "zonalIds");
    zonalOptions.options = this.zonalList;
  },
};
</script>

<style lang="stylus" scoped></style>
